class RolexSerialLookup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.querySelector('input[type="text"]');

    this.defaultWrap = this.querySelector("[data-default-wrap]");
    this.resultsTable = this.querySelector("[data-rolex-results-table]");
    this.rowsWrap = this.querySelector("[data-rows]");
    this.rowProto = this.querySelector("[data-row-proto]");

    this.shellsWrap = this.querySelector("[data-shells]");
    this.shellProto = this.querySelector("[data-shell-proto]");

    this.whereInfo = this.querySelector("[data-where-info]");
    this.yearPanel = this.querySelector("[data-year-panel]");
    this.yearValue = this.querySelector("[data-year-value]");
    this.yearScrollTarget = this.querySelector("[data-year-scroll]");

    if (!this.rowProto || !this.shellProto) {
      console.error(
        "Missing prototype nodes: [data-row-proto] or [data-shell-proto]"
      );
    }

    this.form && this.form.addEventListener("submit", (e) => this.onSubmit(e));
  }

  setText(el, txt) {
    if (el) el.textContent = txt ?? "";
  }
  setHTML(el, html) {
    if (el) el.innerHTML = html ?? "";
  }
  setAttr(el, k, v) {
    if (el && v) el.setAttribute(k, v);
  }

  async onSubmit(e) {
    e.preventDefault();
    const raw = (this.input?.value || "").trim();
    const years = this.findYears(raw);
    if (!years.length) {
      this.resetUI();
      return;
    }

    const sorted = [...years].sort((a, b) => a - b);
    const display = this.compactYears(sorted);

    const btn = this.form?.querySelector('button[type="submit"]');
    const prev = btn?.textContent || "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Searching…";
    }

    try {
      const r = await fetch(
        "https://teddy-baldassarre.vercel.app/api/rolex-models-by-years",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ years }),
        }
      );
      const data = await r.json();
      const matches = Array.isArray(data?.matches) ? data.matches : [];

      if (matches.length > 0) {
        this.renderResults(matches, display, raw);
        this.hideDefaultSections();
      }

      this.hideWhereInfo();

      if (this.yearPanel) {
        this.yearPanel.classList.remove("hidden");
      }
      this.setText(this.yearValue, display);

      if (this.yearScrollTarget) {
        const rect = this.yearScrollTarget.getBoundingClientRect();
        const docTop = rect.top + window.pageYOffset;
        const headerOffset = window.matchMedia("(min-width: 1024px)").matches
          ? 104
          : 0;
        const top = Math.max(0, docTop - headerOffset);
        window.scrollTo({ top, left: 0, behavior: "auto" });
      }
    } catch (err) {
      console.warn("Lookup failed", err);
      this.resetUI();
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = prev;
      }
    }
  }

  hideWhereInfo() {
    if (this.whereInfo) {
      this.whereInfo.classList.add("hidden");
    }
  }

  hideDefaultSections() {
    document
      .querySelectorAll("[data-rolex-default-section]")
      .forEach((el) => el.classList.add("hidden"));
  }

  resetUI() {
    Array.from(
      this.rowsWrap?.querySelectorAll("tr:not([data-row-proto])") || []
    ).forEach((n) => n.remove());
    Array.from(
      this.shellsWrap?.querySelectorAll(
        "[data-shell]:not([data-shell-proto])"
      ) || []
    ).forEach((n) => n.remove());

    if (this.resultsTable) this.resultsTable.classList.add("hidden");
    if (this.defaultWrap) this.defaultWrap.classList.remove("hidden");
    if (this.whereInfo) this.whereInfo.classList.remove("hidden");
    if (this.yearPanel) this.yearPanel.classList.add("hidden");
    this.setText(this.yearValue, "");

    Array.from(this.shellsWrap?.children || []).forEach((s) =>
      s.classList.add("hidden")
    );

    this.form?.reset();
    this.input?.focus();
  }

  renderResults(matches, displayYear, serialInput) {
    Array.from(
      this.rowsWrap?.querySelectorAll("tr:not([data-row-proto])") || []
    ).forEach((n) => n.remove());
    Array.from(
      this.shellsWrap?.querySelectorAll(
        "[data-shell]:not([data-shell-proto])"
      ) || []
    ).forEach((n) => n.remove());

    if (
      !this.rowProto ||
      !this.shellProto ||
      !this.rowsWrap ||
      !this.shellsWrap
    )
      return;

    const rows = [];
    const shells = [];

    matches.forEach((m) => {
      const row = this.rowProto.cloneNode(true);
      row.classList.remove("hidden");
      row.removeAttribute("data-row-proto");

      const thumbSrc = this.firstUrl(
        m.productImage,
        m.productImageUrl,
        m.product_image,
        m.product,
        m.product?.image,
        m.images?.[0]
      );
      this.setAttr(row.querySelector("[data-thumb]"), "src", thumbSrc || "");
      this.setText(row.querySelector("[data-name]"), m.name || "");
      this.setText(
        row.querySelector("[data-reference]"),
        m.reference ? `Ref. ${m.reference}` : ""
      );
      row.querySelectorAll("[data-year]").forEach((el) => {
        this.setText(el, displayYear);
      });

      const shell = this.shellProto.cloneNode(true);
      shell.setAttribute("data-shell", "");
      shell.classList.add("hidden");

      const heroSrc = this.firstUrl(
        m.productImage,
        m.productImageUrl,
        m.product_image,
        m.product,
        m.product?.image
      );
      const lifeSrc = this.firstUrl(
        m.lifestyleImageUrl,
        m.lifestyle_image,
        m.lifestyle,
        m.images?.[1],
        m.images?.[0]
      );

      this.setAttr(
        shell.querySelector("[data-hero]"),
        "src",
        heroSrc || lifeSrc || thumbSrc || ""
      );
      this.setAttr(
        shell.querySelector("[data-lifestyle]"),
        "src",
        lifeSrc || heroSrc || thumbSrc || ""
      );

      shell.querySelectorAll("[data-title]").forEach((el) => {
        this.setText(el, `${m.name || ""}`);
      });
      this.setText(shell.querySelector("[data-serial]"), serialInput || "");
      this.setText(shell.querySelector("[data-name-full]"), m.name || "");
      this.setText(shell.querySelector("[data-year-full]"), displayYear);
      this.setText(
        shell.querySelector("[data-years-range]"),
        this.renderRanges(m.ranges)
      );
      this.setText(
        shell.querySelector("[data-reference-full]"),
        m.reference || ""
      );

      const extraEl = shell.querySelector("[data-extra]");
      if (extraEl) {
        const items = this.extractListItems(m.extraInfo);
        this.setHTML(extraEl, this.makeExtraInfoHtml(items));
      }

      this.setText(
        shell.querySelector("[data-writeup-title]"),
        `About the ${m.name || ""} Ref. ${m.reference || ""}`
      );
      const w = shell.querySelector("[data-writeup]");
      if (w) w.innerHTML = this.richToHtml(m.writeup);

      const back = shell.querySelector("[data-rolex-reset]");
      if (back) {
        back.addEventListener("click", (ev) => {
          ev.preventDefault();
          shell.classList.add("hidden");
          if (this.defaultWrap) this.defaultWrap.classList.remove("hidden");
          if (this.resultsTable) this.resultsTable.classList.remove("hidden");
          window.scrollTo(0, 0);
        });
      }

      this.rowsWrap.appendChild(row);
      this.shellsWrap.appendChild(shell);
      rows.push(row);
      shells.push(shell);

      const btn = row.querySelector("button");
      if (btn) {
        btn.addEventListener("click", (ev) => {
          ev.preventDefault();
          if (this.resultsTable) this.resultsTable.classList.add("hidden");
          if (this.defaultWrap) this.defaultWrap.classList.add("hidden");
          shells.forEach((s) => s.classList.add("hidden"));
          shell.classList.remove("hidden");
          window.scrollTo(0, 0);
        });
      }
    });

    if (this.resultsTable) this.resultsTable.classList.remove("hidden");
  }

  firstUrl(...candidates) {
    for (const c of candidates) {
      if (!c) continue;
      if (typeof c === "string") return c;
      if (typeof c === "object") {
        if (typeof c.url === "string") return c.url;
        if (typeof c.src === "string") return c.src;
        if (typeof c.originalSrc === "string") return c.originalSrc;
        if (typeof c.image === "object") {
          if (typeof c.image.url === "string") return c.image.url;
          if (typeof c.image.src === "string") return c.image.src;
        }
      }
    }
    return "";
  }

  extractListItems(value) {
    if (!value) return [];
    try {
      const json =
        typeof value === "string" &&
        (value.trim().startsWith("{") || value.trim().startsWith("["))
          ? JSON.parse(value)
          : value;

      const items = [];
      const walk = (node) => {
        if (!node) return;
        if (node.type === "list-item") {
          items.push((node.children || []).map(walk).join(""));
          return "";
        }
        if (node.type === "text") return node.value || "";
        if (Array.isArray(node)) return node.map(walk).join("");
        if (node.children) return node.children.map(walk).join("");
        return "";
      };
      const out = walk(json);
      return items.length ? items : out ? [out] : [];
    } catch {
      return String(value)
        .split(/[\n•;]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    }
  }

  makeExtraInfoHtml(items) {
    if (!Array.isArray(items) || !items.length) return "";
    const parts = items
      .map((t, i) => {
        const bullet =
          i === 0 ? "" : `<span class="mx-2" aria-hidden="true">•</span>`;
        const str = String(t);
        const [label, ...rest] = str.split(":");
        const hasColon = rest.length > 0;
        const l = (label || "").trim();
        const v = rest.join(":").trim();

        const content = hasColon
          ? `<span class="caption--large">${l}:</span> <span class="relative -top-[1px] text-sm lg:text-base">${v}</span>`
          : `<span class="relative -top-[1px]">${str}</span>`;

        return `${bullet}${content}`;
      })
      .join("");

    return `<div class="py-3 lg:py-4 flex flex-wrap items-baseline gap-1 lg:gap-2 items-center">
            <span class="caption--large sr-only">Details:</span>
            ${parts}
          </div>`;
  }

  richToHtml(value) {
    if (!value) return "";
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
        try {
          const json = JSON.parse(trimmed);
          return this.richJsonToHtml(json);
        } catch {
          return this.escapeIfPlain(trimmed);
        }
      }
      return value;
    }
    if (typeof value === "object") {
      return this.richJsonToHtml(value);
    }
    return "";
  }

  escapeIfPlain(s) {
    if (/[<][a-zA-Z!/]/.test(s)) return s;
    const div = document.createElement("div");
    div.textContent = s;
    return div.innerHTML;
  }

  richJsonToHtml(rt) {
    const walk = (node) => {
      if (!node) return "";
      const t = node.type;
      if (t === "root") return (node.children || []).map(walk).join("");
      if (t === "paragraph")
        return `<p>${(node.children || []).map(walk).join("")}</p>`;
      if (t === "text") return node.value || "";
      if (t === "list") {
        const tag = node.listType === "ordered" ? "ol" : "ul";
        return `<${tag}>${(node.children || []).map(walk).join("")}</${tag}>`;
      }
      if (t === "list-item")
        return `<li>${(node.children || []).map(walk).join("")}</li>`;
      return (node.children || []).map(walk).join("");
    };
    try {
      const root = typeof rt === "string" ? JSON.parse(rt) : rt;
      return walk(root);
    } catch {
      return "";
    }
  }

  renderRanges(ranges) {
    if (!Array.isArray(ranges) || !ranges.length) return "";
    return ranges
      .map((r) =>
        r.start === r.end ? String(r.start) : `${r.start} – ${r.end}`
      )
      .join(" or ");
  }

  compactYears(arr) {
    if (arr.length === 1) return String(arr[0]);
    const out = [];
    let start = arr[0],
      prev = arr[0];
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] === prev + 1) {
        prev = arr[i];
        continue;
      }
      out.push(start === prev ? `${start}` : `${start}–${prev}`);
      start = prev = arr[i];
    }
    out.push(start === prev ? `${start}` : `${start}–${prev}`);
    return out.join(" or ");
  }

  findYears(raw) {
    if (!raw) return [];
    const cleaned = raw.replace(/[\s,.-]/g, "").toUpperCase();

    if (/^[A-Z]/.test(cleaned)) {
      const ch = cleaned[0];
      const letterYears = this.letterMap()[ch];
      if (letterYears && letterYears.length) {
        return letterYears.filter((y) => !this.skipYears().has(y));
      }
      return this.randomYears();
    }
    if (/\D/.test(cleaned)) return this.randomYears();

    const sn = parseInt(cleaned, 10);
    if (Number.isNaN(sn)) return [];

    const rows = this.numericCutoffs().filter(
      (r) => r.val != null && !this.skipYears().has(r.year)
    );
    const years = new Set();
    for (let i = 0; i < rows.length; i++) {
      const cur = rows[i],
        next = rows[i + 1];
      const lower = cur.val,
        upper = next ? next.val : Infinity;
      if (sn >= lower && sn < upper) years.add(cur.year);
    }
    return Array.from(years);
  }

  randomYears() {
    return [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
  }
  skipYears() {
    return new Set([1931, 1929, 1950, 1949]);
  }
  letterMap() {
    return {
      G: [2010],
      V: [2009, 2008],
      M: [2008, 2007],
      Z: [2007, 2006],
      D: [2006, 2005],
      F: [2005, 2004, 2003],
      Y: [2002],
      K: [2001, 2000],
      P: [2000],
      A: [1999],
      U: [1998, 1997],
      T: [1996],
      W: [1995],
      S: [1994, 1993],
      C: [1992],
      N: [1991],
      X: [1991],
      E: [1990],
      L: [1989],
      R: [1988, 1987],
    };
  }
  numericCutoffs() {
    return [
      { val: 1, year: 1926 },
      { val: 20190, year: 1927 },
      { val: 23969, year: 1928 },
      { val: 23186, year: 1930 },
      { val: 29132, year: 1932 },
      { val: 29562, year: 1933 },
      { val: 30823, year: 1934 },
      { val: 34336, year: 1935 },
      { val: 36856, year: 1936 },
      { val: 40920, year: 1937 },
      { val: 43739, year: 1938 },
      { val: 71224, year: 1939 },
      { val: 99775, year: 1940 },
      { val: 106047, year: 1941 },
      { val: 143509, year: 1942 },
      { val: 230878, year: 1943 },
      { val: 269561, year: 1944 },
      { val: 302459, year: 1945 },
      { val: 367946, year: 1946 },
      { val: 529163, year: 1947 },
      { val: 628840, year: 1948 },
      { val: 709249, year: 1951 },
      { val: 726639, year: 1952 },
      { val: 855726, year: 1953 },
      { val: 23000, year: 1954 },
      { val: 97000, year: 1955 },
      { val: 133061, year: 1956 },
      { val: 224000, year: 1957 },
      { val: 328000, year: 1958 },
      { val: 399453, year: 1959 },
      { val: 516000, year: 1960 },
      { val: 643153, year: 1961 },
      { val: 744000, year: 1962 },
      { val: 824000, year: 1963 },
      { val: 1008889, year: 1964 },
      { val: 1100000, year: 1965 },
      { val: 1200000, year: 1966 },
      { val: 1538435, year: 1967 },
      { val: 1752000, year: 1968 },
      { val: 1900000, year: 1969 },
      { val: 2241882, year: 1970 },
      { val: 2589295, year: 1971 },
      { val: 2890459, year: 1972 },
      { val: 3200268, year: 1973 },
      { val: 3567927, year: 1974 },
      { val: 3862196, year: 1975 },
      { val: 4115299, year: 1976 },
      { val: 5008000, year: 1977 },
      { val: 5000000, year: 1978 },
      { val: 5737030, year: 1979 },
      { val: 6434000, year: 1980 },
      { val: 6520870, year: 1981 },
      { val: 7100000, year: 1982 },
      { val: 7400000, year: 1983 },
      { val: 8070022, year: 1984 },
      { val: 8614000, year: 1985 },
      { val: 8900000, year: 1986 },
      { val: 9400000, year: 1987 },
    ];
  }
}

if (!customElements.get("rolex-serial-lookup")) {
  customElements.define("rolex-serial-lookup", RolexSerialLookup);
}
